const initYandexMetrika = (counterId) => {
    if (!counterId) return;

    for (let script of document.scripts) {
        if (script.src === "https://mc.yandex.ru/metrika/tag.js ") {
            return;
        }
    }

    (function (m, e, t, r, i, k, a) {
        m[i] = m[i] || function () {
            (m[i].a = m[i].a || []).push(arguments)
        };
        m[i].l = 1 * new Date();
        k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a)
    })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js ", "ym");

    window.ym(counterId, "init", {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true
    });

    window.currentMetrikaId = counterId;
};

export { initYandexMetrika };